import { mapper } from "utils/mapping";

export const animationProps = (
  setAnimationState: (animationState: boolean) => void
) =>
  mapper(
    {
      onHover: {
        onHoverStart: () => setAnimationState(true),
        onHoverEnd: () => setAnimationState(false)
      },
      infinite: {
        onViewportEnter: () => setAnimationState(true)
      }
    },
    {}
  );
